<template>
  <!-- 우측 주문서 -->
  <div class="c-order-form">
    <!-- head -->
    <div class="order-form-head">
      <div class="order-form-head-inner">
        <h2 class="c-title-level2">주문서</h2>
        <div class="order-use">
          <strong class="label">주문자</strong>
          <div class="cont">
            <p class="c-text-level2">
              <span class="company">{{ user.zbpName }}</span
              >/<span class="name">{{ user.name }}</span>
            </p>
          </div>
        </div>
        <div class="order-use">
          <strong class="label">영업사원</strong>
          <div class="cont">
            <!-- D: data가 1개일 때 클래스, disabled 추가 -->
            <div
              class="c-select type-small size-full"
              :class="{
                'is-onething':
                  initData.page.userLoginInfo?.empList?.length === 1,
              }"
            >
              <template v-if="initData.page.userLoginInfo?.empList?.length > 0">
                <!-- D: data가 1개일 때 클래스, disabled 추가 -->
                <select
                  v-model="data.selectedBranch"
                  :disabled="initData.page.userLoginInfo?.empList?.length === 1"
                  @change="saleEmpSelect()"
                >
                  <option
                    v-for="(item, index) in user.empList"
                    :key="index"
                    :value="item"
                  >
                    {{ item.zempName }}{{ item.zpositionName }}
                  </option>
                </select>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- body -->
    <div class="order-form-body">
      <div class="scroll-y">
        <div class="scroll-y-inner">
          <div class="delivery-info-wrap">
            <h3 class="c-text-level2 flex-box">
              배송방법
              <!--
                    D: popover 버튼(PC전용)
                    1. 오픈할 클릭 요소에 data-popover-trigger={값} 추가
                    2. 주의사항: 다른 상품이나 요소들에 값이 동일하면 동작이 안합니다.
                  -->
              <button
                type="button"
                class="btn-popover"
                data-popover-trigger="delivery1"
              >
                <i class="c-icon icon-popover size-small"></i>
              </button>
            </h3>
            <!--
                  D: popover 상세(PC전용)
                  1. 오픈시 상세 요소에 data-popover="{값}"
                  2. 클릭시 is-active 추가 ui_app.js에 스크립트 가이드작성함
                -->
            <div class="c-popover-detail" data-popover="delivery1">
              <div class="text">
                - 일반: 고객 사업자 주소지 배송 <br />
                - 조기: 고객 사업자 주소지 배송 <br />
                - 직송: 요청한 주소지 배송 <br />
                - 화물: 화물로 발송 요청<br />
                - 택배: 택배로 발송 요청<br />
                - 직출: 고객 직접 방문
              </div>
            </div>
            <div class="c-select type-small size-full">
              <!-- D: 배송방법선택시 유형 노출 최하단 스크립트 참고 -->
              <select
                name=""
                id=""
                title="배송방법선택"
                data-js-example
                v-model="data.selectedDlvCd"
                @change="selectedDlvCdChange()"
              >
                <option :value="null">배송방법선택</option>
                <option
                  v-for="(item, index) in initData.codes.dlvCmmCdList"
                  :key="index"
                  :value="item.cdVl"
                  :disabled="item.cdVl == 25 ? includeThinner : false"
                >
                  {{ item.cdNm }}
                </option>
              </select>
            </div>
            <!-- D: 지역/지점 선택 케이스1 -->
            <div
              v-if="data.selectedDlvCd === '20'"
              class="select-group flex-box"
            >
              <div class="c-select type-small size-full">
                <select
                  name=""
                  id=""
                  title="지역선택"
                  v-model="data.selectedDlvRgn"
                >
                  <option :value="null">지역선택</option>
                  <option
                    v-for="(item, index) in initData.codes.dlvRgnList"
                    :key="index"
                    :value="item.cdVl"
                  >
                    {{ item.cdNm }}
                  </option>
                </select>
              </div>
              <div class="c-select type-small size-full">
                <select
                  name=""
                  id=""
                  title="지점선택"
                  v-model="data.selectedDlvPnt"
                >
                  <option :value="null">지점선택</option>
                  <option
                    v-for="(item, index) in dlvPntList"
                    :key="index"
                    :value="item.branchNm"
                  >
                    {{ item.branchNm }}
                  </option>
                </select>
              </div>
            </div>

            <div
              class="delivery-select"
              v-if="
                data.selectedDlvCd === '20' ||
                data.selectedDlvCd === '25' ||
                data.selectedDlvCd === '30' ||
                data.selectedDlvCd === '18'
              "
            >
              <h3 class="c-text-level2">인수자</h3>
              <div class="c-form-field">
                <label class="c-input-group type-small">
                  <input
                    type="text"
                    title="인수자명"
                    placeholder="인수자명을 적어주세요"
                    maxlength="10"
                    v-model="data.selectedAddress.acptrNm"
                  />
                </label>
              </div>
            </div>

            <div
              class="delivery-select"
              v-if="data.selectedDlvCd === '25' || data.selectedDlvCd === '18'"
            >
              <h3 class="c-text-level2">유선전화</h3>
              <div class="c-form-field">
                <label class="p-input-group type-small">
                  <div class="c-select-small">
                    <select
                      class="c-select-small-select"
                      v-model="data.acptrWrdTelno1"
                    >
                      <option value="">선택</option>
                      <option
                        v-for="number in wiredExcNumbers"
                        :key="number"
                        :value="number"
                      >
                        {{ number }}
                      </option>
                    </select>
                  </div>
                  <span>-</span>
                  <input
                    type="text"
                    title="중간번호입력"
                    maxlength="4"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                    v-model="data.acptrWrdTelno2"
                  />
                  <span>-</span>
                  <input
                    type="text"
                    title="끝번호입력"
                    maxlength="4"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                    v-model="data.acptrWrdTelno3"
                  />
                </label>
              </div>
            </div>

            <div
              class="delivery-select"
              v-if="
                data.selectedDlvCd === '20' ||
                data.selectedDlvCd === '25' ||
                data.selectedDlvCd === '18'
              "
            >
              <h3 class="c-text-level2">핸드폰</h3>
              <div class="c-form-field">
                <label class="p-input-group type-small">
                  <!-- 휴대폰 번호 입력창 병합 2025.11.25 -->
                  <div class="c-select-small">
                    <select
                      class="c-select-small-select"
                      v-model="data.acptrMblTelno1"
                    >
                      <option value="">선택</option>
                      <option
                        v-for="number in mobileExcNumbers"
                        :key="number"
                        :value="number"
                      >
                        {{ number }}
                      </option>
                    </select>
                  </div>
                  <span>-</span>
                  <input
                    type="text"
                    title="중간번호,끝번호 입력"
                    maxlength="8"
                    v-model="data.acptrMblTelnoRest"
                    @input="onMobileRestInput"
                  />
                  <!-- <input
                    type="text"
                    title="중간번호입력"
                    maxlength="4"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                    v-model="data.acptrMblTelno2"
                  />
                  <span>-</span>
                  <input
                    type="text"
                    title="끝번호입력"
                    maxlength="4"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                    v-model="data.acptrMblTelno3"
                  /> -->
                </label>
              </div>
            </div>

            <!-- D: 배송지 선택 케이스2 -->
            <div
              v-if="data.selectedDlvCd === '25' || data.selectedDlvCd === '18'"
              class="delivery-select"
            >
              <h3 class="c-text-level2">배송지정보</h3>
              <a
                href="#"
                class="underline"
                @click.prevent="
                  () => (initData.isShowDeliveryAddressPop = true)
                "
                >배송지선택</a
              >
            </div>
            <div
              v-if="data.selectedDlvCd === '25' || data.selectedDlvCd === '18'"
            >
              <div class="c-form-field">
                <label class="c-input-group type-small">
                  <input
                    type="text"
                    maxlength="10"
                    title="우편번호"
                    placeholder="우편번호"
                    v-model="data.selectedAddress.zip"
                    readonly
                  />
                </label>
                <button
                  type="button"
                  class="c-util-button type-line-black type-small"
                  @click="openKakaoPostcode"
                  :disabled="
                    data.selectedAddress?.bscDlvdesYn == 'Y' &&
                    data.selectedDlvCd != '25' &&
                    data.selectedDlvCd != '18'
                  "
                >
                  <span class="fw-nr">주소찾기</span>
                </button>
              </div>
              <div class="c-form-field">
                <label class="c-input-group type-small">
                  <input
                    type="text"
                    title="주소"
                    placeholder="주소"
                    v-model="data.selectedAddress.roadNmBscAddr"
                    readonly
                  />
                </label>
              </div>
              <div class="c-form-field">
                <label class="c-input-group type-small">
                  <input
                    type="text"
                    title="상세 주소"
                    placeholder="상세주소"
                    v-model="data.selectedAddress.roadNmDtlAddr"
                    maxlength="50"
                    @input="addressDtlInput"
                    :readonly="
                      data.selectedAddress.bscDlvdesYn == 'Y' &&
                      data.selectedDlvCd != '25' &&
                      data.selectedDlvCd != '18'
                    "
                  />
                </label>
              </div>
              <!-- <div class="delivery-destination">
                <span class="d-name">{{ data.selectedAddress?.acptrNm }}</span>
                <span class="d-address"
                  >{{ data.selectedAddress?.roadNmBscAddr }}
                  {{ data.selectedAddress?.roadNmDtlAddr }}</span
                >
                <span class="d-phone"
                  >연락처: {{ data.selectedAddress?.acptrMblTelno }}</span
                >
              </div> -->
            </div>

            <!-- D: [2024-12-20] 출고지 추가 -->
            <!-- D: 출고지 선택 케이스2 -->
            <div v-if="data.selectedDlvCd === '30'" class="delivery-select">
              <h3 class="c-text-level2">출고지</h3>
              <div class="delivery-destination">
                <span class="d-factory">{{
                  initData.codes.userWerksList[0]?.cdNm
                }}</span>
              </div>
            </div>
            <!-- // D: [2024-12-20] 출고지 추가 -->

            <div class="c-form-field">
              <label class="c-input-group type-small">
                <input
                  type="text"
                  title="기타 요청사항"
                  placeholder="기타 요청사항을 적어주세요"
                  maxlength="50"
                  v-model="data.dlvDmndCn"
                />
              </label>
            </div>
          </div>

          <div class="product-list">
            <!-- D: 상품 단순 유형 type-simple 추가 -->
            <div class="c-products type-simple">
              <!-- D: 서브 전용 상품 컴포넌트 -->
              <OrderSheetItem
                v-for="(item, index) in itemList"
                :key="item.goodsSn"
                :item="item"
                :index="index"
                @select="(item) => emit('select', item)"
                @delete="(idx) => deleteItem(idx)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="order-total">
      <div class="order-total-item">
        <h3 class="c-text-level2">주문 총액</h3>
        <strong class="price">
          <span class="system">{{
            Number(data.totalPrice).toLocaleString()
          }}</span
          >원</strong
        >
      </div>
      <div class="order-total-item">
        <h3 class="c-text-level2">배송 요청일</h3>
        <div v-show="data.selectedDlvCd !== '15'" class="c-button-calendar">
          <input
            type="text"
            readonly
            title="배송 요청일"
            data-datepicker
            ref="datepickerRef"
            v-model="data.selectedDate"
          />
        </div>
        <div v-show="data.selectedDlvCd === '15'">{{ data.selectedDate }}</div>
      </div>
    </div>

    <!-- button -->
    <div class="c-btn-area type-product">
      <button
        type="button"
        class="c-button type-black type-xsmall type-icon"
        data-basket="orderbasket"
        @click.stop="addCart()"
      >
        <i class="c-icon icon-basket-product-black"></i>
        <span class="sr-only">장바구니</span>
      </button>
      <!-- 2024-12-16 문구 변경 -->
      <button
        type="button"
        class="c-button type-primary type-xsmall"
        @click.stop="orderNow()"
      >
        <span>주문</span>
      </button>
    </div>
  </div>

  <AgencyDeliveryAddressPop
    v-if="initData.isShowDeliveryAddressPop"
    :dlvdesSn="data.selectedAddress?.dlvdesSn"
    @close="() => (initData.isShowDeliveryAddressPop = false)"
    @select="(address) => (data.selectedAddress = address)"
  />
</template>

<script setup>
import {
  ref,
  defineExpose,
  onMounted,
  reactive,
  inject,
  watch,
  computed,
  defineEmits,
} from "vue";
import { popoverTrigger } from "@/js/_ui";
import { api } from "@/plugins/api";
import $ from "jquery";
import { useAuthStore } from "@/store";
import { getLocalStorage } from "@/utils/cmUtil";
import { useToast } from "@/components/paintpro/composables/useToast";
import AgencyDeliveryAddressPop from "@/components/paintpro/agency/agencyDeliveryAddressPop.vue";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil";
import * as orderApi from "@/api/orderApi.js";
import * as store from "@/store";
import utils from "@/js/utils";
import { useRoute } from "vue-router";
import router from "@/router";
import OrderSheetItem from "./orderSheetItem.vue";
const { isMobile } = cmUtil.useDeviceType();

const url = inject("url_prefix");
const authStore = useAuthStore();
const route = useRoute();
let user = reactive({});
const { showToast } = useToast();
const datepickerRef = ref(null);
const emit = defineEmits(["select"]);

const itemList = computed(() => store.useOrderListStore().itemList);
const dlvPntList = ref(null); // 배송지점 리스트
const thinnerList = ref(null); // 신나 리스트
const includeThinner = ref(false); // 신나 포함 여부
const mobileExcNumbers = [
  "010",
  "011",
  "016",
  "017",
  "018",
  "019",
  "0502",
  "0503",
  "0504",
  "0508",
]; // 휴대폰 국번 리스트
const wiredExcNumbers = [
  "02",
  "031",
  "032",
  "033",
  "041",
  "042",
  "043",
  "044",
  "051",
  "052",
  "053",
  "054",
  "055",
  "061",
  "062",
  "063",
  "064",
  "070",
]; // 유선 국번 리스트
const initData = reactive({
  page: {
    isLogin: false,
    deviceType: isMobile.value ? "M" : "P",
    userLoginInfo: {},
    basketCount: {},
    breadcrumbItems: [{ name: "", path: "" }],
    empIndex: 0,
    path: "",
  },
  codes: {
    dlvCmmCdList: [], // 배송방법코드
    dlvRgnList: [], // 배송지역
    userWerksList: [], // 플랜트(지점)
  },
  popup: {
    isShowDeliveryAddressPop: false, // 배송지팝업
    isSaleEmpLayer: false,
  },
  eventBus: {
    salesPersonIndex: 0,
  },
});

const data = reactive({
  selectedDlvCd: null, // 배송방법코드
  selectedDlvCdNm: null, // 배송방법코드명
  selectedDlvRgn: null, // 배송지역
  selectedDlvPnt: null, // 배송지점
  totalPrice: computed(() =>
    itemList.value.reduce((sum, item) => {
      return sum + item.kbetr * item.quantity;
    }, 0)
  ), // 총 가격
  defaultAddress: null, // 기본배송지
  selectedAddress: {
    dlvdesSn: null /* 배송지일련번호 */,
    agencySn: null /* 대리점일련번호 */,
    dlvdesNm: null /* 배송지명 */,
    acptrNm: null /* 인수자명 */,
    acptrWrdTelno: null /* 인수자유선전화번호 */,
    acptrMblTelno: null /* 인수자휴대전화번호 */,
    acptrTelno1: null /* 인수자전화번호1 */,
    acptrTelno2: null /* 인수자전화번호2 */,
    zip: null /* 우편번호 */,
    ozip: null /* 구우편번호 */,
    roadNmBscAddr: null /* 도로명기본주소 */,
    roadNmDtlAddr: null /* 도로명상세주소 */,
    lotnoBscAddr: null /* 지번기본주소 */,
    lotnoDtlAddr: null /* 지번상세주소 */,
    bscDlvdesYn: null /* 기본배송지여부 */,
    useYn: null /* 사용여부 */,
    rgtr: null /* 등록자 */,
    regDt: null /* 등록일시 */,
    mdfr: null /* 수정자 */,
    mdfcnDt: null /* 수정일시 */,
  }, // 배송지
  selectedDate: null, // 배송요청일
  dlvDmndCn: null, // 배송요청내용
  selectedBranch: null, // 담당영업사원
  defaultAddr: null, // 기본배송지 여부
  acptrWrdTelno1: null,
  acptrWrdTelno2: null,
  acptrWrdTelno3: null,
  acptrMblTelnoSub1: null,
  acptrMblTelnoSub2: null,
  acptrMblTelnoSub3: null,
  // 휴대폰 번호 입력창 병합 2025.11.25
  acptrMblTelno1: null,
  // acptrMblTelno2: null,
  // acptrMblTelno3: null,
  acptrMblTelnoRest: null, // 휴대폰 번호
});
const data_backup = reactive({
  selectedDlvCd: null, // 배송방법코드
  selectedDlvCdNm: null, // 배송방법코드명
  selectedDlvRgn: null, // 배송지역
  selectedDlvPnt: null, // 배송지점
  selectedDate: null, // 배송요청일
  dlvDmndCn: null, // 배송요청내용
});

const userData = computed(() => {
  return {
    orderStatusCd: "0", // 주문상태코드 (주문대기:0)
    agencySn: user.agencySn, // 대리점 일련번호
    kunnr: user.kunnr, // 대리점 아이디
    zempNo: data.selectedBranch.kunn2, // 영업사원 아이디
    orderChnlCd: initData.page.deviceType, // PC, MOBILE
    dlvMthdCd: data.selectedDlvCd, // 배송방법코드
    dlvMthdCdNm: data.selectedDlvCdNm, // 배송방법코드명
    dlvdesSn: data.selectedAddress?.dlvdesSn || "", // 배송지 일련번호
    dlvDmndCn: data.dlvDmndCn, // 배송요청사항
    dlvDmndDay: data.selectedDate?.replace(/-/g, "") || "", // 배송요청일
    dlvRgnCd: data.selectedDlvRgn, // 대신화물 지역명
    dlvBranchCd: data.selectedDlvPnt, // 대신화물 지점명
    dlvdesNm: data.selectedAddress?.dlvdesNm || "", // 배송지명
    acptrNm: data.selectedAddress?.acptrNm || "", // 인수자명
    acptrWrdTelno:
      data.selectedDlvCd != "25" &&
      data.selectedDlvCd != "20" &&
      data.selectedDlvCd != "18"
        ? data.selectedAddress?.acptrWrdTelno || ""
        : utils.isNotBlank(data.acptrWrdTelno1) == true
          ? data.acptrWrdTelno1 +
            "-" +
            data.acptrWrdTelno2 +
            "-" +
            data.acptrWrdTelno3
          : "", // 인수자 전화번호
    acptrMblTelno:
      data.selectedDlvCd != "25" &&
      data.selectedDlvCd != "20" &&
      data.selectedDlvCd != "18"
        ? data.selectedAddress?.acptrMblTelno || ""
        : // 휴대폰 번호 입력창 병합 2025.11.25
          // : utils.isNotBlank(data.acptrMblTelno1) == true
          //   ? data.acptrMblTelno1 +
          //     "-" +
          //     data.acptrMblTelno2 +
          //     "-" +
          //     data.acptrMblTelno3
          //   : "", // 인수자 휴대전화번호
          buildMobileNumber(data.acptrMblTelno1, data.acptrMblTelnoRest),
    acptrTelno1: data.selectedAddress?.acptrTelno1 || "", // 인수자 전화번호1
    zip: data.selectedAddress?.zip || "", // 우편번호
    roadNmBscAddr: data.selectedAddress?.roadNmBscAddr || "", // 도로명기본주소
    roadNmDtlAddr: data.selectedAddress?.roadNmDtlAddr || "", // 도로명상세주소
    defaultAddr:
      data.selectedDlvCd == "25" || data.selectedDlvCd == "18"
        ? "N"
        : data.defaultAddr || "", // 기본배송지 여부
    werksNm: initData.codes.userWerksList[0]?.cdNm, // 직출명
  };
});

const headerDataParam = computed(() => {
  return {
    CYB_ORDER: "", // 사이버샵 주문번호
    ERDAT_CYB: "", // 주문일
    ERZET_CYB: "", // 주문시간
    ERNAM_CYB: "10", // 생성자
    AUART: "ZOR1", // 문서유형
    VKORG: data.selectedBranch.vkorg, // 영업조직
    VTWEG: data.selectedBranch.vtweg, // 유통경로
    SPART: data.selectedBranch.spart, // 제품군
    VKBUR: data.selectedBranch.vkbur, // 영업소
    VKGRP: data.selectedBranch.vkgrp, // 영업그룹
    KUNNR_SP_CYB: user.kunnr, // 판매처 (대리점 아이디)
    KUNNR_SH_CYB: user.kunnr, // 납품처 (대리점 아이디)
    KUNNR_SE_CYB: data.selectedBranch.kunn2, // 영업사원 아이디
    NETWR_CYB: data.totalPrice, // 주문 총 금액
    WAERK: "KRW", // 전표통화
    VDATU: data.selectedDate?.replace(/-/g, "") || "", // 배송요청일
    VSBED: data.selectedDlvCd, // 배송코드
    MEMO_TEXT: data.dlvDmndCn, // 배송요청사항
    AGENCY_NAME: data.selectedDlvPnt, // 대신화물 지점명
    BNAME: data.selectedAddress?.acptrNm || "", // 인수자명
    TELF1:
      data.selectedDlvCd != 20 &&
      data.selectedDlvCd != 25 &&
      data.selectedDlvCd != "18"
        ? data.selectedAddress?.acptrMblTelno || ""
        : // 휴대폰 번호 입력창 병합 2025.11.25
          // : data.acptrMblTelno1 +
          //   "-" +
          //   data.acptrMblTelno2 +
          //   "-" +
          //   data.acptrMblTelno3, // 인수자 휴대전화번호
          buildMobileNumber(data.acptrMblTelno1, data.acptrMblTelnoRest),

    POST_CODE1: data.selectedAddress?.zip || "", // 우편번호
    CITY1: data.selectedAddress?.roadNmBscAddr || "", // 도로명 기본주소
    STREET: data.selectedAddress?.roadNmDtlAddr || "", // 도로명 상세주소
    CITY2: "", // 도로명 구역
  };
});

const itemListParam = ref([]);
const updateItemListParam = () => {
  itemListParam.value = itemList.value.map((item) => ({
    CYB_ORDER: "", // 주문번호
    CYB_ORDER_ITEM_NO: "", // 주문품목번호
    MATNR: item.matnr, // 자재번호
    KWMENG_CYB: item.quantity, // 수량
    VRKME: "EA", // 판매단위 // TODO item.kmein 로 수정
    NETPR_CYB: item.kbetr, // 품목단가
    NETWR_CYB: item.kbetr * item.quantity, // 품목금액
    WERKS: user.vwerk, // 플랜트
    //  DELIVERY_SITE: , // 배송처
    CAN_REQ_SYS: "", // 취소요청 시스템
    CAN_FLAG: "", // 취소플래그
    CAN_DATE: "", // 취소일자
    CAN_TIME: "", // 취소시간
    CAN_REASON: "", //취소사유
    GOODS_SN: item.goodsSn, // 제품 일련번호
    ZZMAKTX: item.zzmaktx, // 제품명
  }));

  // 배송방법 화물(20),직출(30)인 경우 배송지 관련 빈값
  if (data.selectedDlvCd == 20 || data.selectedDlvCd == 30) {
    data.selectedAddress.dlvdesSn = ""; // 배송지일련번호
    data.selectedAddress.dlvdesNm = ""; // 배송지명
    data.selectedAddress.zip = ""; // 우편번호
    data.selectedAddress.roadNmBscAddr = ""; // 도로명기본주소
    data.selectedAddress.roadNmDtlAddr = ""; // 도로명상세주소
  }

  // 기본배송지면 빈값으로 변경 (SAP 요구사항)
  if (data.selectedAddress.bscDlvdesYn == "Y") {
    data.defaultAddr = "Y";
  }

  // 배송방법코드명
  data.selectedDlvCdNm = initData.codes.dlvCmmCdList.find(
    (item) => item.cdVl == data.selectedDlvCd
  )?.cdNm;
};

async function orderNow() {
  // 유효성 체크
  if (!(await checkValidation())) return;

  cmUtil.loading("", { duration: 60000 });

  updateItemListParam(); // 주문시 필요값들 itemListParam

  if (data.selectedDlvCd === "18") {
    const resWerks = await api.get(`${url}/order/getPostWerk`, {
      params: { post: data.selectedAddress.zip },
    });

    if (resWerks.data.retCnt > 0) {
      for (var i = 0; i < itemListParam.value.length; i++) {
        itemListParam.value[i].WERKS = resWerks.data.werks;
      }
    } else {
      cmUtil.loadingHide();
      await cmUtil.alert(
        "<b>직송배송 불가 지역 안내</b><br><b>배송지 : </b>[" +
          resWerks.data.deliverySite +
          "] <br>물류상 사유로 인한 직송 배송 불가<br>해당 배송지 주문 필요 시<br>담당영업사원 문의 부탁드립니다."
      );
      return;
    }
  }

  for (var j = 0; j < itemListParam.value.length; j++) {
    const spWerkCnt = await api.get(`${url}/order/getSpecificWerks`, {
      params: { matnr: itemListParam.value[j].MATNR },
    });

    if (spWerkCnt.resultCode >= 1) {
      itemListParam.value[j].WERKS = "1004"; //특정 제품의 경우 안산공장
    }
  }

  const params = {
    api: {
      SD_HEADER: { item: headerDataParam.value },
      SD_ITEM: { item: itemListParam.value },
    },
    info: userData.value,
  };

  const res = await api.post(`${url}/order/doOrder`, params);
  cmUtil.loadingHide();
  if (res.resultCode === 200) {
    const confirmOrder = await cmUtil.alert("msg", { type: "orderComplete" });
    clearSheet();
    if (confirmOrder) {
      router.push({
        path: "/paintpro/orderList",
      });
    }
  } else {
    if (res.data) {
      itemList.value.forEach((item) => {
        item.qtyLack = false;

        res.data.forEach((itemData) => {
          if (itemData.matnr === item.matnr) {
            item.qtyLack = true;
            item.availability = utils.currency(itemData.zztotalQty);
          }
        });
      });
    } else {
      itemList.value.forEach((item) => {
        item.qtyLack = false;
      });
    }
  }
}

const addressDtlInput = () => {
  //주소에 특정 특수문자 제거
  data.selectedAddress.roadNmDtlAddr =
    data.selectedAddress.roadNmDtlAddr.replace(/[\t"|]/g, "");
};

// 바로주문서 초기화
function clearSheet() {
  store.useOrderListStore().resetItemList();
  itemListParam.value = [];
  Object.assign(data, data_backup);
  data.selectedAddress = Object.assign({}, data.defaultAddress);
}

onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

async function pageInit() {
  await pageInitData();
  searchCmd();
}

async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  mparm.push({ qId: "cmCode_code1", parm: { cdGrp: "DLV_MTHD_CD" } });
  mparm.push({ qId: "cmCode_code2", parm: { cdGrp: "DLV_RGN_CD" } });
  mparm.push({
    qId: "cmCode_code3",
    parm: { cdGrp: "WERKS", dataRole: "vwerk" },
  });

  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message}`);
    return false;
  }

  const { cmCode_code1, cmCode_code2, cmCode_code3 } = res.data;
  initData.page.token = getLocalStorage("token");
  initData.page.isLogin = authStore?.user ? true : false;
  initData.page.userLoginInfo = authStore?.user;
  initData.codes.dlvCmmCdList = cmCode_code1;
  initData.codes.dlvRgnList = cmCode_code2;
  initData.codes.userWerksList = cmCode_code3;
  initData.page.path = route.path;
  user = authStore?.user;

  // 영업사원 디폴트
  initData.page.empIndex = store.useEventBusStore()?.salesPersonIndex;
  data.selectedBranch = user.empList[initData.page.empIndex];
}

async function searchCmd() {
  getDefaultDlv(); // 기본배송지
  getThinnerList(); // 신나 리스트
  popoverTrigger(); // 팝오버
  jqueryDatepicker(); // 달력
}

// 기본배송지 API
async function getDefaultDlv() {
  const res = await api.get(`${url}/order/getDefaultAddress`);
  data.defaultAddress = res.data;
  data.selectedAddress = Object.assign({}, data.defaultAddress);
}

// 배송지역 변경 시
watch(
  () => data.selectedDlvRgn,
  (newValue) => {
    data.selectedDlvRgn = newValue;
    data.selectedDlvPnt = null;
    getDlvPntList();
  }
);

watch(
  () => data.selectedAddress.dlvdesSn,
  (newValue) => {
    if (newValue) {
      inputTelInit();
    }
  }
);

function inputTelInit() {
  // 휴대폰 번호 입력창 병합 2025.11.25
  // if (utils.isNotBlank(data.selectedAddress.acptrMblTelno)) {
  //   data.acptrMblTelno1 = data.selectedAddress.acptrMblTelno.split("-")[0];
  //   data.acptrMblTelno2 = data.selectedAddress.acptrMblTelno.split("-")[1];
  //   data.acptrMblTelno3 = data.selectedAddress.acptrMblTelno.split("-")[2];
  // } else {
  //   data.acptrMblTelno1 = "";
  //   data.acptrMblTelno2 = "";
  //   data.acptrMblTelno3 = "";
  // }
  const mbl = data.selectedAddress.acptrMblTelno;

  if (utils.isNotBlank(mbl)) {
    const parts = mbl.split("-");
    const prefix = parts[0] || "";
    const mid = parts[1] || "";
    const last = parts[2] || "";

    data.acptrMblTelno1 = prefix;
    data.acptrMblTelnoRest = (mid + last).slice(0, 8); // "1234" + "5678" -> "12345678"
  } else {
    data.acptrMblTelno1 = "";
    data.acptrMblTelnoRest = "";
  }

  if (utils.isNotBlank(data.selectedAddress.acptrWrdTelno)) {
    data.acptrWrdTelno1 = data.selectedAddress.acptrWrdTelno.split("-")[0];
    data.acptrWrdTelno2 = data.selectedAddress.acptrWrdTelno.split("-")[1];
    data.acptrWrdTelno3 = data.selectedAddress.acptrWrdTelno.split("-")[2];
  } else {
    data.acptrWrdTelno1 = "";
    data.acptrWrdTelno2 = "";
    data.acptrWrdTelno3 = "";
  }
}

// 배송지점 리스트 API
async function getDlvPntList() {
  const res = await api.get(`${url}/order/getDlvPntList`, {
    params: { dlvRgn: data.selectedDlvRgn },
  });
  dlvPntList.value = res.data;
}

// 신나 리스트 API
async function getThinnerList() {
  const res = await api.get(`${url}/order/getThinnerList`);
  thinnerList.value = res.data;
}

// 제품 추가
const addItemList = async (itemParam) => {
  let item = { ...itemParam };

  // 모바일은 주문서로 바로 이동
  if (initData.page.deviceType == "M") {
    await globalOrderNow(item);
    return;
  }

  // 주제인 경우만 세트제품 체크
  if (item.zzlqdCls === "A") {
    // 세트제품
    const res = await orderApi.checkSetProduct(item.goodsSn);
    if (res.set) {
      const matnr = res.matnr;
      const getItemRes = await api.get(
        `${url}/product/item/${utils.replace(matnr, "/", "-")}`
      );
      if (getItemRes.resultCode === 200) {
        // 세트제품으로 변경
        item = { ...getItemRes.data, quantity: 1 };
      } else {
        return;
      }
    }
  }

  // 중복 체크
  const dupCheck = itemList.value.some((obj) => obj.matnr === item.matnr);
  if (dupCheck) {
    // 제품 목록에 중복 전달
    showToast("이미 주문서에 담은 제품입니다.", {
      type: "basket", // type은 케이스별 class 추가하는 역할
    });
  } else {
    store.useOrderListStore().addItem(item);
    showToast("주문서에 담겼습니다.", {
      type: "basket", // type은 케이스별 class 추가하는 역할
    });
  }
};

// 임시주문
async function globalOrderNow(item) {
  const params = {
    goodsSn: item.goodsSn,
    goodsQty: item.goodsQty,
    zempNo: data.selectedBranch?.kunn2,
    path: initData.page.path,
  };

  await orderApi.createTempOrder(params);
}

watch(itemList.value, () => {
  // 신나류 체크
  includeThinner.value = itemList.value.some((item) =>
    thinnerList.value.some((thinner) => item.prodh3 == thinner.clsfCd)
  );
  // 제품 가격
  itemList.value.forEach((item) => {
    item.itemPrice = item.kbetr * item.quantity;
  });
});

// 신나류 포함시 배송방법초기화
watch(
  () => includeThinner.value,
  () => {
    if (includeThinner.value) {
      data.selectedDlvCd = null;
    }
  }
);

// 배송방법 택배 외 선택시 기본배송지로 변경
watch(
  () => data.selectedDlvCd,
  (newValue) => {
    if (newValue !== "25") {
      data.selectedAddress = Object.assign({}, data.defaultAddress);
    }
  }
);

async function checkValidation() {
  if (itemList.value.length === 0) {
    await cmUtil.alert("주문서에 제품이 없습니다.");
    return false;
  }
  if (data.selectedDlvCd === null) {
    await cmUtil.alert("배송방법을 선택하세요.");
    return false;
  }
  if (data.selectedDlvCd === "20") {
    if (data.selectedDlvRgn === null) {
      await cmUtil.alert("대신화물 지역을 선택하세요.");
      return false;
    }
    if (data.selectedDlvPnt === null) {
      await cmUtil.alert("대신화물 지점을 선택하세요.");
      return false;
    }
  }

  if (
    data.selectedDlvCd === "18" ||
    data.selectedDlvCd === "20" ||
    data.selectedDlvCd === "25"
  ) {
    if (utils.isBlank(data.selectedAddress.acptrNm)) {
      await cmUtil.alert("받는 분을 입력하세요.");
      return false;
    }
    if (data.selectedAddress.acptrNm.length > 10) {
      await cmUtil.alert("받는 분의 최대 길이는 10입니다.");
      return false;
    }
    // if (isNaN(data.acptrWrdTelno2)) {
    //   await cmUtil.alert("유선 전화의 가운데 번호를 숫자로만 입력하세요");
    //   return false;
    // }
    // if (isNaN(data.acptrWrdTelno3)) {
    //   await cmUtil.alert("유선 전화의 마지막 번호를 숫자로만 입력하세요");
    //   return false;
    // }

    // 휴대폰 번호 입력창 병합 2025.11.25
    if (utils.isBlank(data.acptrMblTelno1)) {
      await cmUtil.alert("휴대폰 번호의 국번을 선택해주세요.");
      return false;
    }
    // if (utils.isBlank(data.acptrMblTelno2)) {
    //   await cmUtil.alert("휴대폰 번호의 가운데 번호를 입력하세요.");
    //   return false;
    // }
    // if (utils.isBlank(data.acptrMblTelno3)) {
    //   await cmUtil.alert("휴대폰 번호의 마지막 번호를 입력하세요.");
    //   return false;
    // }
    // if (isNaN(data.acptrMblTelno2)) {
    //   await cmUtil.alert("휴대폰 번호의가운데 번호를 숫자로만 입력하세요");
    //   return false;
    // } else if (isNaN(data.acptrMblTelno3)) {
    //   await cmUtil.alert("휴대폰 번호의마지막 번호를 숫자로만 입력하세요");
    //   return false;
    // }

    if (utils.isBlank(data.acptrMblTelnoRest)) {
      await cmUtil.alert("휴대폰 번호 뒷자리를 입력하세요.");
      return false;
    }
    const digits = data.acptrMblTelnoRest.replace(/\D/g, "");
    if (digits.length !== 7 && digits.length !== 8) {
      await cmUtil.alert("휴대폰 번호 뒷자리는 8자리로 입력하세요.");
      return false;
    }
  }

  if (data.selectedDlvCd === "25" || data.selectedDlvCd === "18") {
    if (
      utils.isBlank(data.selectedAddress.zip) ||
      utils.isBlank(data.selectedAddress.roadNmBscAddr)
    ) {
      await cmUtil.alert("주소를 입력하세요.");
      return false;
    }
  }

  if (data.selectedDate === null) {
    await cmUtil.alert("배송요청일을 선택하세요.");
    return false;
  }

  return true;
}

// 제품 삭제
function deleteItem(index) {
  store.useOrderListStore().removeItem(index);
}

// 장바구니 담기
async function addCart() {
  const addList = itemList.value.map((item) => ({
    goodsSn: item.goodsSn,
    goodsQty: item.quantity,
  }));
  const res = await cmApi.insertUserBasketProds(addList); // 장바구니 추가
  if (res.resultCode == 200) {
    clearSheet();
  }
}

// 영업사원 선택
function saleEmpSelect() {
  initData.page.empIndex = initData.page.userLoginInfo.empList.findIndex(
    (item) => item.kunn2 == data.selectedBranch.kunn2
  );
  store.useEventBusStore().setSalesPersonIndex(initData.page.empIndex);
  cmApi.updateUserPersonInfo({
    type: "saleEmpSelect",
    chcZempNo: data.selectedBranch.kunn2,
  });
}

watch(
  () => store.useEventBusStore()?.salesPersonIndex,
  (newValue) => {
    initData.eventBus.salesPersonIndex = newValue;
    if (
      newValue >= 0 &&
      initData.page.userLoginInfo?.empList?.length > newValue
    ) {
      initData.page.empIndex = newValue;
      data.selectedBranch = user.empList[initData.page.empIndex];
    }
  }
);

// jquery 달력
function jqueryDatepicker() {
  if (datepickerRef.value == null) return;
  $(datepickerRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    minDate: 0,
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      // 날짜 선택 후 추가 작업 가능
      data.selectedDate = dateText;
    },
  });
}

function selectedDlvCdChange() {
  data.selectedAddress = Object.assign({}, data.defaultAddress);
  if (
    data.selectedDlvCd === "20" ||
    data.selectedDlvCd === "25" ||
    data.selectedDlvCd === "18"
  ) {
    // 휴대폰 번호 입력창 병합 2025.11.25
    // data.acptrMblTelno1 = data.selectedAddress.acptrMblTelno.split("-")[0];
    // data.acptrMblTelno2 = data.selectedAddress.acptrMblTelno.split("-")[1];
    // data.acptrMblTelno3 = data.selectedAddress.acptrMblTelno.split("-")[2];
    const mbl = data.selectedAddress.acptrMblTelno;
    if (utils.isNotBlank(mbl)) {
      const parts = mbl.split("-");
      const prefix = parts[0] || "";
      const mid = parts[1] || "";
      const last = parts[2] || "";

      data.acptrMblTelno1 = prefix;
      data.acptrMblTelnoRest = (mid + last).slice(0, 8);
    } else {
      data.acptrMblTelno1 = "";
      data.acptrMblTelnoRest = "";
    }
    data.acptrWrdTelno1 = data.selectedAddress.acptrWrdTelno.split("-")[0];
    data.acptrWrdTelno2 = data.selectedAddress.acptrWrdTelno.split("-")[1];
    data.acptrWrdTelno3 = data.selectedAddress.acptrWrdTelno.split("-")[2];
  }

  if (data.selectedDlvCd === "25" || data.selectedDlvCd === "18") {
    data.selectedAddress.zip = "";
    data.selectedAddress.roadNmBscAddr = "";
    data.selectedAddress.roadNmDtlAddr = "";
  }

  if (data.selectedDlvCd === "15") {
    const today = new Date();
    let resultDate = new Date(today);
    resultDate.setDate(today.getDate() + 1);
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    let resultDateStr = resultDate.toLocaleDateString("en-CA", options);
    data.selectedDate = resultDateStr;
  } else {
    data.selectedDate = null;
  }
}

defineExpose({
  addItemList,
});

// 우편번호 검색 API를 여는 함수
const openKakaoPostcode = async () => {
  if (
    typeof window.daum === "undefined" ||
    typeof window.daum.Postcode === "undefined"
  ) {
    await cmUtil.alert("카카오 우편번호 API가 로드되지 않았습니다.");
    return;
  }

  new window.daum.Postcode({
    oncomplete: function (result) {
      data.selectedAddress.zip = result.zonecode;
      data.selectedAddress.ozip = "";
      data.selectedAddress.roadNmBscAddr =
        result.userSelectedType === "R" // R: 도로명, J: 지번
          ? result.roadAddress
          : result.jibunAddress;
      data.selectedAddress.lotnoBscAddr = result.jibunAddress;

      data.selectedAddress.roadNmDtlAddr = "";
      data.selectedAddress.lotnoDtlAddr = "";
    },
  }).open();
};

// 휴대폰 번호 입력창 병합 2025.11.25
function onMobileRestInput(e) {
  // 숫자만 허용 + 최대 8자리
  const onlyDigits = e.target.value.replace(/\D/g, "");
  data.acptrMblTelnoRest = onlyDigits.slice(0, 8);
}

function buildMobileNumber(prefix, rest) {
  if (utils.isBlank(prefix) || utils.isBlank(rest)) return "";

  const digits = rest.replace(/\D/g, "");

  if (digits.length === 8) {
    // 4-4로: 010-1234-5678
    return `${prefix}-${digits.slice(0, 4)}-${digits.slice(4)}`;
  }

  if (digits.length === 7) {
    // 3-4로: 011-234-5678 같은 케이스
    return `${prefix}-${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  return `${prefix}-${digits}`;
}
</script>
